import {
  CurvatureType,
  AdequateType,
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
  IntersectionApproachType,
  PresenceType,
  SpeedAverageType,
  TreatmentType,
} from "@keita/lanepatrol-sdk";
import { CraNodeCoding } from "../../coding/models/CraNodeCoding";

export function applyTreatmentToCraNodeCoding(
  treatmentType: TreatmentType,
  codingEntry: CraNodeCoding
) {
  const { attributes } = codingEntry;
  switch (treatmentType) {
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithLightSegregation: {
      attributes.facilityType = FacilityType.OnRoadBicycleLane;
      attributes.lightSegregation = PresenceType.Present;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane0To1m: {
      attributes.adjacentFeatures0to1m!.roadLane = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane1To3m: {
      attributes.adjacentFeatures1to3m!.roadLane = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToACyclingPriorityStreet: {
      attributes.roadOperatingSpeed = 20;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToAMultiUsePath: {
      attributes.facilityType = FacilityType.MultiUsePath;
      attributes.facilityWidthPerDirection = FacilityWidth.Wide;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToAnOffRoadBicyclePath: {
      attributes.facilityType = FacilityType.OffRoadBicyclePath;
      break;
    }
    case TreatmentType.UpgradeExistingFacilityToAOneWayBicycleFacility: {
      attributes.flowDirection = FlowDirectionType.OneWay;
      break;
    }
    case TreatmentType.ImproveSurfaceConditions: {
      attributes.looseOrSlipperySurface = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.InstallLightSegregation: {
      attributes.lightSegregation = PresenceType.Present;
      break;
    }
    case TreatmentType.InstallLighting: {
      attributes.streetLighting = PresenceType.Present;
      break;
    }
    case TreatmentType.ClearFacilityRemovedFixedObstacle: {
      attributes.fixedObstacleOnFacility = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ClearFacilityRemovedNonFixedObstacles: {
      attributes.nonFixedObstacleOnFacility = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ClearFacilityRemoveWidthRestriction: {
      attributes.widthRestriction = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ImproveFacilityAccess: {
      attributes.facilityAccess = AdequateType.Adequate;
      break;
    }
    case TreatmentType.RedesignTheCurve: {
      attributes.curvature = CurvatureType.NoSharpTurn;
      break;
    }
    case TreatmentType.WidenTheFacility: {
      attributes.facilityWidthPerDirection = FacilityWidth.Wide;
      break;
    }
    case TreatmentType.InstallProtectiveBarrier: {
      attributes.adjacentFeatures0to1m!.severeHazard = PresenceType.NotPresent;
      attributes.adjacentFeatures1to3m!.severeHazard = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ImproveDelineation: {
      attributes.delineation = PresenceType.Present;
      break;
    }
    case TreatmentType.ReviewIntersectionApproach: {
      attributes.intersectionApproach = IntersectionApproachType.SeparateOrNA;
      break;
    }
    case TreatmentType.ImproveSafetyOrCrossingDesign: {
      attributes.crossingFacility = PresenceType.Present;
      break;
    }
    case TreatmentType.EvaluateNeedForGradeSeparation: {
      attributes.intersectionOrRoadCrossing = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ReconfigureOrRemoveParking: {
      attributes.adjacentFeatures0to1m!.vehicleParking =
        PresenceType.NotPresent;
      break;
    }
    case TreatmentType.ReviewConfigurationOfTrainTramRails: {
      attributes.tramOrTrainRails = PresenceType.NotPresent;
      break;
    }
    case TreatmentType.InstallTrafficCalming: {
      attributes.roadOperatingSpeed = 30;
      break;
    }
    case TreatmentType.VehiclesSpeedControl: {
      attributes.roadOperatingSpeed = attributes.roadSpeedLimit!;
      break;
    }
    case TreatmentType.BicyclesSpeedControl: {
      attributes.bicycleAndLVSpeedAverage = SpeedAverageType.LessThan20kmh;
      break;
    }
    default:
      console.warn("applyTreatmentToCraNodeCoding: treatment not implemented.");
  }
}
